export default "__VITE_ASSET__Dl1J3HwM__"